import { getContext } from '@fiverr-private/fiverr_context';
import { EXPERIMENTS, ALLOCATIONS } from '@fiverr-private/listing_experiments';
import { isEligibleForBookPublishingExperience } from '../../experiments/bookPublishing';

interface UseBookPublishingExperimentProps {
    dominateSubCategoryId: string;
}

export const useBookPublishingExperiment = ({ dominateSubCategoryId }: UseBookPublishingExperimentProps) => {
    const { abTests } = getContext();
    const isInBookPublishingQuestionnaireTest =
        abTests[EXPERIMENTS.CHEETAHS_BOOK_PUBLISHING] === Number(ALLOCATIONS.TEST_B);
    const shouldRenderBookPublishingQuestionnaire =
        isInBookPublishingQuestionnaireTest && isEligibleForBookPublishingExperience(Number(dominateSubCategoryId));
    return { shouldRenderBookPublishingQuestionnaire, isInBookPublishingQuestionnaireTest };
};
